<template>
    <section id="services" class="features_area pt-120">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-6">
          <div class="section_title text-center pb-25">
            <h4
              class="title wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
            >
              Serviços Contábeis
            </h4>
            <p
              class="wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.4s"
            >
              Nossos Consultores estão aqui prontos para atendê-lo!
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-6">
          <div
            class="single_features text-center mt-60 wow fadeInUp"
            data-wow-duration="1.3s"
            data-wow-delay="0.2s"
          >
            <i class="lni lni-briefcase"></i>
            <h4 class="features_title">Gestão Empresarial</h4>
            <p>
              Gestão empresarial é uma estratégia de condução de negócios a
              melhores resultados, partindo de ações que envolvem a organização
              de processos, o controle das finanças, a administração dos
              recursos humanos e materiais e tudo aquilo que é essencial para a
              sua manutenção.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div
            class="single_features text-center mt-60 wow fadeInUp"
            data-wow-duration="1.3s"
            data-wow-delay="0.3s"
          >
            <i class="lni lni-clipboard"></i>
            <h4 class="features_title">Planejamento Fiscal</h4>
            <p>
              O planejamento fiscal ou planejamento fiscal é uma forma de
              minimizar os custos fiscais. Sucintamente, o planejamento fiscal
              terá de respeitar a lei de forma integral, procurando no entanto
              negócios jurídicos com menor ou nula tributação. Esta é uma
              atividade lícita, e devidamente tutelada na forma jurídica.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div
            class="single_features text-center mt-60 wow fadeInUp"
            data-wow-duration="1.3s"
            data-wow-delay="0.4s"
          >
            <i class="lni lni-handshake"></i>
            <h4 class="features_title">Assessoria Trabalhista</h4>
            <p>
              Apurar e emitir os contracheques dos colaboradores; Calcular o
              pró-labore dos sócios ou recibo do único proprietário da empresa;
              Emitir as guias do INSS, FGTS e do Imposto de Renda Retido na
              Fonte (IRRF); Processar a Folha de Pagamento (incluindo 13°
              salário e pagamento de férias); Fazer os relatórios dos dados da
              Folha para o Fisco trabalhista; Processar a documentação nos casos
              de admissão e demissão; Preencher o Cadastro Geral de Empregados e
              Desempregados (CAGED).
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div
            class="single_features text-center mt-60 wow fadeInUp"
            data-wow-duration="1.3s"
            data-wow-delay="0.2s"
          >
            <i class="lni lni-invention"></i>
            <h4 class="features_title">Planejamento Tributário</h4>
            <p>
              Esse serviço contábil ajuda a empresa a economizar ao estudar os
              detalhes da legislação tributária, reduzindo a carga de impostos
              incidente e ainda cumprindo as normas corretamente. A assessoria
              deve ser feita por um contador confiável, para não acabar
              interpretando equivocadamente as leis e isso prejudicar o negócio.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div
            class="single_features text-center mt-60 wow fadeInUp"
            data-wow-duration="1.3s"
            data-wow-delay="0.3s"
          >
            <i class="lni lni-invest-monitor"></i>
            <h4 class="features_title">Assessoria para Gestão Financeira</h4>
            <p>
              Outro serviço estratégico que o contador pode fazer é contribuir
              para a gestão financeira, oferecendo dados que irão amparar a
              tomada de decisão e analisando o desempenho da área. O
              profissional pode trazer informações relevantes para os
              administradores, que passariam despercebidas sem sua participação.
              Assim, a empresa ganha ao contar com mais um serviço contábil
              especializado para traçar seu caminho para o sucesso.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div
            class="single_features text-center mt-60 wow fadeInUp"
            data-wow-duration="1.3s"
            data-wow-delay="0.4s"
          >
            <i class="lni lni-calendar"></i>
            <h4 class="features_title">Entrega das Obrigações Acessórias</h4>
            <p>
              Declaração de Informações Socioeconômicas e Fiscais (DEFIS) —
              para optantes do Simples Nacional; Documento de Arrecadação do
              Simples Nacional (DAS); Declaração de Débitos Tributários Federais
              (DCTF) — optantes do Lucro Presumido, Lucro Real e, em alguns
              casos, também o Simples Nacional; Declaração de Imposto Retido na
              Fonte (DIRF); Relação Anual de Informações Sociais (RAIS); Entre
              outros.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  //props: ['textconteudo', 'icon', 'title'],
};
</script>

<style scoped>

</style>